import PropTypes from 'prop-types'

import ProductImage from '@/components/ProductImage'

const ProductImageLink = ({ action, productImageUrl }) => (
  <button
    aria-hidden='true'
    className='product-info__image u-hard'
    onClick={action}
    tabIndex='-1'
  >
    <ProductImage
      aria-hidden='true'
      className='product-cover__image'
      url={productImageUrl}
      width={90}
    />
  </button>
)

ProductImageLink.propTypes = {
  action: PropTypes.func,
  productImageUrl: PropTypes.string.isRequired
}

export default ProductImageLink
